import { getEuVatIdExample, isEuVatIdFormatValid, normalizeEuVatId } from './eu-vat-id.utils';

const SWISS_TAX_ID = /^CHE(\d{3})(\d{3})(\d{3})(MWST|TVA|IVA|HR)?$/;

/** Keep Swiss IDs in Stripe's canonical display format; preserve whether VAT was specified. */
export const normalizeBillingTaxId = (value: string): string => {
  const compact = normalizeEuVatId(value);
  const swiss = SWISS_TAX_ID.exec(compact);
  if (!swiss) return compact;
  const uid = `CHE-${swiss[1]}.${swiss[2]}.${swiss[3]}`;
  const suffix = swiss[4];
  if (!suffix) return uid;
  return `${uid} ${suffix === 'HR' ? 'HR' : 'MWST'}`;
};

export const isBillingTaxIdFormatValid = (value: string, countryIsoCode?: string | null): boolean => {
  if (countryIsoCode?.toUpperCase() !== 'CH') return isEuVatIdFormatValid(value, countryIsoCode);
  const compact = normalizeEuVatId(value);
  return !compact || SWISS_TAX_ID.test(compact);
};

export const getBillingTaxIdExample = (countryIsoCode?: string | null): string =>
  countryIsoCode?.toUpperCase() === 'CH' ? 'CHE-123.456.789' : getEuVatIdExample(countryIsoCode);
